module.exports = __webpack_public_path__ + "img/link.4a49620c.png";